import type { CommentSubjectVersion } from '../../../data-contract/comment';
import type { CommentsSubjectKind } from '../../subject/comments-subject';

export type CommentCacheScope = {
    readonly architectureId: string;
    readonly itemId: string;
    readonly version: CommentSubjectVersion;
};

export type CommentMutationVerb = 'create-comment' | 'create-reply' | 'delete-comment' | 'resolve-comment';

export const createCommentKeys = (subjectKind: CommentsSubjectKind) => {
    const prefix = ({ architectureId, itemId, version }: CommentCacheScope) =>
        ['comments', subjectKind, architectureId, itemId, version] as const;

    return {
        prefix,
        list: (scope: CommentCacheScope, language: string) => [...prefix(scope), language] as const,
        allLanguages: (scope: CommentCacheScope) => [...prefix(scope), 'all-languages'] as const,
        // 'replies' root sits outside the 'comments' prefix so prefix invalidations never reach replies
        replies: ({ architectureId, itemId, version }: CommentCacheScope, parentCommentId: string) =>
            ['replies', subjectKind, architectureId, itemId, version, parentCommentId] as const,
        mutation: (verb: CommentMutationVerb, { architectureId, itemId, version }: CommentCacheScope) =>
            [verb, subjectKind, architectureId, itemId, version] as const,
    } as const;
};

export type CommentKeys = ReturnType<typeof createCommentKeys>;
